/**
 * Set Steps headline be the same height and the top of the background curve to be at the bottom of the headline
 */
jQuery(document).ready(function ($) {
    function initStepsBlock() {
        $('.flex-content.step').each(function () {
            const $block = $(this);
            const $h3s = $block.find('.step-item h3');
            if (!$h3s.length) return;

            // Reset before measuring so we get natural heights
            $h3s.css('height', '');

            // Equalize h3 heights
            let maxHeight = 0;
            $h3s.each(function () {
                maxHeight = Math.max(maxHeight, $(this).outerHeight());
            });
            $h3s.css('height', maxHeight + 'px');

            // Position background-curve top at the bottom of the h3 area
            const $curve = $block.find('.background-curve');
            if (!$curve.length) return;

            const blockTop = $block.offset().top;
            const h3Bottom = $h3s.first().offset().top + $h3s.first().outerHeight();
            $curve.css({ top: (h3Bottom - blockTop) + 'px', bottom: 'auto' });
        });
    }
    $(window).on('load', initStepsBlock);

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initStepsBlock, 100);
    });
});